import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FlaggedFormsService {

  private dataSource = new BehaviorSubject(null);
  
  constructor(
    private _http: HttpClient
  ) { }

  refreshCount(data: any[]) {
    this.dataSource.next(data);
  }
  
  getFlaggedForms(organizationId) {
      console.log("Got fdomr id", organizationId)
    return this._http.get(environment.url + "/flaggedForms/" + organizationId);
  }

  restoreFlaggedForms(requestData) {
    return this._http.put(environment.url + "/forms/flagged/restore", requestData);
  }
}
